import { render } from "./TccClientView.vue?vue&type=template&id=1c5bee98&scoped=true"
import script from "./TccClientView.vue?vue&type=script&lang=js"
export * from "./TccClientView.vue?vue&type=script&lang=js"

import "./TccClientView.vue?vue&type=style&index=0&id=1c5bee98&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5bee98"]])

export default __exports__